export const json = {
  slide1: [
    {
      url: 'https://timesofindia.indiatimes.com/city/chennai/frontline-doctor-needs-lung-transplant/articleshow/79089119.cms',
      divClass: 'w250',
      target: '_blank',
      alt: 'Times of India',
      imgClass: 'toi'
    },
    {
      url: 'https://economictimes.indiatimes.com/tech/startups/ketto-looks-to-double-its-headcount-in-2021/articleshow/79940566.cms',
      divClass: 'w150',
      target: '_blank',
      alt: 'ET',
      imgClass: 'et'
    },
    {
      url: 'https://www.indiatimes.com/news/india/karnataka-students-crowdfunding-for-classmates-524925.html',
      divClass: 'w150',
      target: '_blank',
      alt: 'India Times',
      imgClass: 'it'
    },
    {
      url: 'https://www.hindustantimes.com/art-and-culture/indian-dance-protege-begins-london-ballet-lessons-amid-lockdown/story-3CeQqgd7m0KMAi7kVUjohJ.html',
      divClass: 'w150',
      target: '_blank',
      alt: 'Hindustan Times',
      imgClass: 'ht'
    },
    {
      url: 'https://www.vice.com/en/article/889pxb/indian-ballet-dancer-kamal-singh-crowdfunded-his-way-to-dance-school',
      divClass: 'w250',
      target: '_blank',
      alt: 'Vice',
      imgClass: 'vice'
    },
    {
      url: 'https://www.afaqs.com/interviews/our-view-is-that-people-donate-money-but-they-do-it-a-bit-differently-kettos-varun-sheth',
      divClass: 'w150',
      target: '_blank',
      alt: 'Afaqs',
      imgClass: 'afaqs'
    },
    {
      url: 'https://www.financialexpress.com/industry/sme/cafe-sme/msme-fin-crowdfunding-is-a-great-way-for-new-businesses-to-test-the-waters-before-launching-product-going-big/2110545/',
      divClass: 'w150',
      target: '_blank',
      alt: 'Financial Express',
      imgClass: 'fe'
    },
    {
      url: 'https://www.expresshealthcare.in/covid19-updates/we-have-seen-four-times-growth-in-fundraiser-campaigns-during-the-lockdown-varun-sheth/424399/',
      divClass: 'w250',
      target: '_blank',
      alt: 'Express Healthcare',
      imgClass: 'eh'
    }
  ]
};
